<template>
    <div>
      <div v-for="(msg, i) in activities" :key="i">
        <div class="msg-container row" :class="msg.createdFromPortal ? 'from-portal' : 'from-flota'">
          <div class="speech-bubble">
            <div class="small activity-name">{{msg.createdFromPortal ? msg.portalUserName : msg.userName ? ('Autoflota - ' + msg.userName) : msg.contactName}}</div>
            <div class="activity-text">{{msg.description}}</div>
            <div class="small">{{formatDateChat(msg.created) + ' ' + formatTime(msg.created)}}</div>
          </div>
        </div>
      </div>
      <div class="row activity-input-container">
          <fg-input class="activity-input"
                    :placeholder='$t( "contacts.typeMessage")'
                    addon-left-icon="fa fa-pencil"
                    v-model="newActivityText"
                    v-on:keyup.enter="sendNewActivity(ticketId)">
          </fg-input>
          <p-button class="send-activity-btn" size="sm" type="success" :disabled="newActivitySendInProgress || !newActivityText" @click="sendNewActivity(ticketId)"  v-if="!newActivitySendInProgress"><i class="nc-icon nc-send"></i></p-button>
          <div class="spinner-container-activity" v-if="newActivitySendInProgress">
            <div class="spinner-border" role="status">
              <span class="sr-only">{{ $t( "general.loading") }}</span>
            </div>
          </div>
      </div>
    </div>
</template>
<script>

  import moment from 'moment'
  import alerts from 'src/util/alerts.js'



  import swal from 'sweetalert2'


  export default {
    inheritAttrs: false,
    name: 'ticket-activities',
    components: {
    },
    props: {
        activities: {
            type: Array,
            description: ''
        },
        ticketId: {
            type: String,
            description: ''
        },
        flatEntityId: {
            type: String,
            description: ''
        }
    },
    data() {
      return {
        newActivityText: '',
        newActivitySendInProgress: false
      }
    },
    watch: {},
    mounted () {
      moment.locale(this.$store.user.data.language);
    },
    methods: {
      formatTime(date) {
        if (!date) return '-';
        date = moment(date);
        return `${date.format('HH:mm')}`
      },
      formatDateChat(date) {
        if (!date) return '-';
        date = moment(date);
        if (date.isSame(moment(), 'day')) return 'today, '
        return `${date.format('ddd').replace('.', '')}, ${date.format('DD.MM.YY')}`
      },
      sendNewActivity(ticketId) {
        if (!this.newActivityText) return;
        let that = this;
        swal({
          title: this.$t('vehicleRequests.sendNewMessage'),
          text: `"${this.newActivityText}"`,
          type: 'info',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-fill',
          confirmButtonText: this.$t('vehicleRequests.yesSend'),
          cancelButtonText: this.$t('general.cancel'),
          buttonsStyling: false
        }).then(function (res) {
          that.newActivitySendInProgress = true;
          that.$store.fleet.actions.sendActivity(that.newActivityText, ticketId, that.flatEntityId, true)
            .then( (error) => {
              that.newActivitySendInProgress = false;
              if (error) return alerts.error(error);
              that.newActivityText = '';
            })
            .catch( (err) => {
              console.error('problemi;', err);
              that.newActivitySendInProgress = false;
            })
        }).catch( (err) => {console.log(err); that.newActivitySendInProgress = false;});
      }
    }
  }
</script>
<style scoped>
  .refresh-btn {
    float: right;
  }
  .spinner-container-activity {
    margin-left: 5px;
  }
  .action-button {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .action-button i {
    font-size: 22px !important;
  }
  .status-icon {
    font-size: 30px !important;
  }
  .status-icon.info {
    color: #51bcda;
  }
  .status-icon.danger {
    color: #ef8157;
  }
  .status-icon.success {
    color: #6bd098;
  }

  .speech-bubble {
    position: relative;
    background: #00aabb;
    border-radius: .4em;
    padding: 1px 6px 1px 6px;
    margin-left: auto;

  }
  .msg-container {
    width: fit-content;
    margin-top:10px;
  }

  .from-portal .speech-bubble:after {
    content: '';
    position: absolute;
    top: 50%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    margin-top: -10px;
    right: 0;
    border-left-color: #B0E7ED;
    border-right: 0;
    border-bottom: 0;
    margin-right: -20px;
    margin-left: auto;
  }
  .from-flota {
    text-align:left;
  }
  .from-flota .speech-bubble {
    background-color: #FDD8A0;
  }

  .from-portal {
    text-align:right;
    margin-left: auto;
  }
  .from-portal .speech-bubble {
    background-color: #B0E7ED;
  }

  .activity-name {
    font-weight: bold;
  }
  .activity-text {
    font-size: 1em;
  }
  .activity-datetime {
    color: gray;
  }
  .activity-input-container {
    margin-top: 20px;
    margin-right: -40px;
  }
  .activity-input {
    width: 88%;
    background-color: white;
    text-align: center;
  }
  .send-activity-btn {
    height: 38px;
    background-color: #B0E7ED !important;
    color: black;
    font-size: 16px;
    padding: 5px 10px;
  }
  .send-activity-btn[disabled] {
    height: 38px;
    background-color: #B0E7ED !important;
    color: black;
    font-size: 16px;
    padding: 5px 10px;
  }
  .send-activity-btn:hover {
    background-color: #5db5bf !important;
  }
</style>
